import Button from "@mui/material/Button";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { useDeleteFileModal } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const DeleteFileDialog = () => {
    const { isOpen, closeModal, payload } = useDeleteFileModal();
    const { response, makeRequest, loading, error } = useApiHook();
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setSubmitRequested(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        if (payload?.onSuccess) {
            payload.onSuccess(response.data);
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, response, submitRequested]);

    const onConfirmHandler = () => {
        if (!payload?.fileId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/file/delete', 'post', { fileId: payload.fileId });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DeleteForeverIcon fontSize="large" />
                    <Typography variant="h5">Elimina file</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmHandler}
                        disabled={loading}
                        sx={{
                            backgroundColor: '#2196f3',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: '#1976d2'
                            }
                        }}
                    >
                        Si
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        No
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body1">
                    Confermi di voler eliminare il file{payload?.fileName ? ` "${payload.fileName}"` : ''}?
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile eliminare il file. Riprova.
                    </Alert>
                )}
            </Stack>
        </ResponsiveDialog>
    );
};

export default DeleteFileDialog;
